module.exports = __webpack_public_path__ + "img/Banner-Quanta-Bank-04.46f3dc66.jpg";